<style scoped>
.insight-panel-content >>> .v-expansion-panel-content__wrap {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.no-radius-header {
  border-radius: 0px;
}
</style>

<template>
  <v-expansion-panel :value="panel" @input="$emit('input')">
    <v-expansion-panel-header class="primary--text no-radius-header" :expand-icon="expandIcon">
      {{ title }}

      <template v-slot:actions="scope">
        <slot name="actions" v-bind="scope" />
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="insight-panel-content">
      <slot />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'AnchorBaseInsightExpansionPanel',
  props: {
    title: String,
    expandIcon: {
      type: String,
      default: '$expand',
    },
    panel: Array,
  },
};
</script>
